import { useTranslation } from "@opendash/i18n";
import { Form, InputNumber } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../../../context/PathContext";
import { TicketMetaField } from "../../../../types/field_configs/Meta";

type Props = {
  field: Extract<TicketMetaField, { type: "number" }>;
};

export const NumberOptions = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <>
      <Form.Item
        name={[...path, "min"]}
        label={t("maintenance:ticket.creation.config.form.field.min")}
      >
        <InputNumber />
      </Form.Item>
      <Form.Item
        name={[...path, "max"]}
        label={t("maintenance:ticket.creation.config.form.field.max")}
      >
        <InputNumber />
      </Form.Item>
    </>
  );
});
